module.exports = __webpack_public_path__ + "static/talkbox-icon-e205c3c0203642d51a811c0e709be540.png";